export default __webpack_public_path__ + "static/media/IMG_0041_6_11zon.3658e72e.jpg";